export default __webpack_public_path__ + "static/media/person-5.4f971cff.png";